"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingScreen = LoadingScreen;
const react_1 = __importDefault(require("react"));
const ui_1 = require("@creature-chess/ui");
const useStyles_1 = require("~/useStyles");
const PageBackground_1 = require("../PageBackground");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    root: {
        position: "relative",
        overflow: "hidden",
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
    },
    foreground: {
        position: "absolute",
        inset: 0,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "clamp(1rem, 5vw, 1.75rem)",
        padding: "0.5rem",
    },
    logo: {
        width: "auto",
        height: "clamp(3.5rem, 16vw, 5.5rem)",
    },
    card: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "clamp(1rem, 5vw, 1.5rem)",
        width: "100%",
        maxWidth: "460px",
        padding: "clamp(1.5rem, 7vw, 2.5rem)",
        boxSizing: "border-box",
        background: theme.palette.surface,
        borderRadius: "0.9rem",
    },
    message: {
        margin: 0,
        fontFamily: theme.typography.primary,
        fontSize: "clamp(1.1rem, 5vw, 1.5rem)",
        textTransform: "uppercase",
        letterSpacing: "0.25em",
        color: theme.palette.light.neutral,
        fontWeight: 700,
        textAlign: "center",
    },
}));
function LoadingScreen({ message }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(PageBackground_1.PageBoardBackground, null),
        react_1.default.createElement("div", { className: classes.foreground },
            react_1.default.createElement("img", { src: `${APP_IMAGE_ROOT}/ui/logo.png`, alt: "Creature Chess", className: classes.logo }),
            react_1.default.createElement("div", { className: classes.card },
                react_1.default.createElement(ui_1.Spinner, { size: "clamp(2.5rem, 12vw, 3.5rem)" }),
                message && react_1.default.createElement("p", { className: classes.message }, message)))));
}
